import {
    Box,
    createStyles,
} from "@mantine/core";

import pverifyIcon from "../../assets/img/pverify-946.png";
import availityIcon from "../../assets/img/availity-2700.png";



const useStyles = createStyles(() => ({
    tagBox: {
        display: "flex",
        flexDirection: "row",
        gap: "14px",
        borderStyle: "solid",
        borderWidth: "2px",
        borderRadius: '4px',
        borderColor: "#9DCDF3",
        padding: "4px 12px 4px 12px",
        alignItems: "center",
    },
    suppLogoPverify: {
        height: '38px',
        width: '71px',
    },
    suppLogoAvaility: {
        height: '32px',
        width: '80px',
    },
}));
interface Props {
    serviceType?: any;

}

export const ServiceTag: React.FC<Props> = ({
    serviceType
}) => {
    const { classes } = useStyles();

    return (
        <>
            <Box className={classes.tagBox}>
                {serviceType === 'pverify'
                    ? <img src={pverifyIcon} className={classes.suppLogoPverify} />
                    : <img src={availityIcon} className={classes.suppLogoAvaility} />
                }
                {/* <Text size={14} weight={600} tt={'capitalize'} color="#262930">{serviceType}</Text> */}
            </Box>
        </>
    );
};
